import { IDecideNextStep } from "../../services/wizard/next-step-decider/next-step-decider.interface";
import { MilitaryServiceStepComponent } from "../../wizard/military-service-step/military-service-step.component";
import { WizardStepBase } from "./wizard-step-base.model";

export class MilitaryServiceStep extends WizardStepBase {
  constructor(id: string, name: string, path: string, nextStepDecider?: IDecideNextStep) {
    super(id, name, path, nextStepDecider);
    this.component = MilitaryServiceStepComponent;
  }
}